export const MODEL = {
  INVOICE: "invoice",
  ESTABLISHMENT: "establishment",
  COMPANY: "company",
  CERTIFICATES: "companySettings",
  USER: "user",
  ENTITY: "entity",
};
